module.exports = __webpack_public_path__ + "img/DK70558114.0dbcc9ec.png";